import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=32c7817c&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=32c7817c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c7817c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c7817c')) {
      api.createRecord('32c7817c', component.options)
    } else {
      api.reload('32c7817c', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=32c7817c&scoped=true", function () {
      api.rerender('32c7817c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/csgUser/list/components/DataForm.vue"
export default component.exports